import React from 'react';
import messages from "res/messages/farsi";

import IconTitleValue from "components/textValue/IconTitleValue";

import {useHistory} from "react-router-dom";
import getColorByTicketStatus from "./TicketUtility";

import {IsM_SM} from "my-styles/media/media";

import ICCalender from "res/images/calendar.png";

import ICStatus from "res/images/done.png";
import ICEdit from "res/images/edit.png";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";

import ICLeftArrow from "res/images/left_arrow.png";
import {Divider} from "@material-ui/core";
import StandardButton from "components/buttons/StandardButton";
import ICArrowBackIosIcon from "res/images/left_arrow_dark.png";
import ICComment from "res/images/comment.png";

export default function Ticket(props) {

    const history = useHistory()
    let ticket = props.ticket
    let itemCount = IsM_SM() ? 3 : 5

    const onShowticketDetail = (e) => {
        props.onNavigate(history, '/ticketDetail', {
            ticket_id: ticket.id,
            page: props.page
        })
        e.stopPropagation()
    }

    const truncateText = (text, maxLength) => {
        // Ø¬Ø¯Ø§ Ú©Ø±Ø¯Ù ÙØªÙ Ø¨Ù Ú©ÙÙØ§Øª
        const words = text.split(' ');

        // Ø§Ú¯Ø± ØªØ¹Ø¯Ø§Ø¯ Ú©ÙÙØ§Øª Ú©ÙØªØ± ÛØ§ ÙØ³Ø§ÙÛ Ø¨Ø§ maxLength Ø¨Ø§Ø´Ø¯Ø ÙÛÚ ØªØºÛÛØ±Û ÙØ¯Ù
        if (words.length <= maxLength) {
            return text;
        }

        // Ø¨Ø±Ø´ Ø§ÙÙÛÙ ØªØ§ maxLength
        const truncatedWords = words.slice(0, maxLength);

        // Ø§Ø¶Ø§ÙÙ Ú©Ø±Ø¯Ù Ø³Ù ÙÙØ·Ù Ø¨Ù Ø§ÙØªÙØ§ Ù ØªØ¨Ø¯ÛÙ Ø¨Ù ÙØªÙ
      return  truncatedWords.join(' ') + '...';

    };


    return (<div className="fullWidth marginSmall responseCardTicket">
        {
        <div className="marginTopBottomSmall card fullHeight" onClick={onShowticketDetail}>
            <div className="horizontalFullScreen">
                <div className="card_blue_left_curve_ticket marginTopBottomMedium">
                    <IconTitleValue
                        valueClassName={"whiteColor"}
                        titleClassName={"whiteColor"}
                        title={messages.ticketNumber}
                        value={ticket.id}/>
                </div>
                <div style={{position: "absolute", left: "0"}} className="marginTopBottomMedium">
                    <div className={ticket.status_type===0 ? "card_light_blue_right_curve_ticket" :"card_green_right_curve_ticket"}>
                        <IconTitleValue
                            valueClassName={"whiteColor"}
                            titleClassName={"whiteColor"}

                            value={ticket.status}/>
                    </div>

                </div>
            </div>
            <div className="marginRightSmall">
                <IconTitleValue
                    valueClassName={getColorByTicketStatus(ticket.status_type) + " mediumTextBold"}
                    icon={<img src={ICEdit} alt="ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"  className="xxSmallIcon"/>}
                    title={messages.subject}
                    value={ticket.title}/>
                <IconTitleValue
                    valueClassName={"mediumTextBold"}
                    icon={<img src={ICComment} alt="ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"  className="xxSmallIcon"/>}
                    title={messages.messageDescription}
                    value={truncateText(ticket.message,10)}/>
                <IconTitleValue
                    valueClassName={"mediumTextBold"}
                    icon={<img src={ICCalender} alt="ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"  className="xxSmallIcon"/>}
                    title={messages.RegistrationDate}
                    value={ticket.dataShamsi} />

            </div>

            {
                <div>
                    <table className="horizontalFullScreen" style={{marginBottom:'3rem'}}>
                        <tbody>
                        <tr>
                            {
                                props.ticketImages.map((value, index) => {

                                          if(value.length>0){
                                              return (
                                                  <td key={index}>
                                                      <div className="horizontalScreen">
                                                          <img src={value} alt="ØµØ±ÙÙ ÙØ§Ø±Ú©Øª-Ù¾Ø´ØªÛØ¨Ø§ÙÛ"  className="largeIcon"/>
                                                          <div>
                                                              <Divider orientation={"vertical"}/>
                                                          </div>
                                                      </div>
                                                  </td>
                                              )
                                          }

                                        })

                            }

                            {
                                props.ticketImages.length > 1 ? (
                                    <td>
                                        <StandardButton
                                            icon={<img src={ICArrowBackIosIcon} alt="ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"  className="xxxxSmallIcon"  />}
                                            onClick={onShowticketDetail}
                                        />
                                    </td>
                                ) : null
                            }

                        </tr>
                        </tbody>
                    </table>
                </div>
            }
            <div className="horizontalScreen" style={{float: "left"}}>
                {
                    <div className="marginSmall" style={{position:'absolute',left:0,bottom:'0.2rem'}}>
                        <IconTitleButtonRound
                            height={"2.7em"}
                            direction="ltr"
                            fontSize="smallTextBold"
                            title={messages.detail}
                            icon={<img className="xxSmallIcon" src={ICLeftArrow} alt="ØµØ±ÙÙ ÙØ§Ø±Ú©Øª" />}
                            iconLeft='true'
                            onClick={onShowticketDetail}/>
                    </div>
                }
            </div>

        </div>
        }

    </div>)
}